import { customerServicePermissionsSchema, type CustomerServicePermission } from './service-permissions.js';
import { z } from 'zod';

export const createAccountUserSchema = z.object({
  name: z.string().trim().min(1).max(120),
  email: z.string().trim().toLowerCase().email(),
  password: z.string().min(12).max(256),
  accountAdmin: z.boolean().default(false),
  servicePermissions: customerServicePermissionsSchema.default([]),
}).strict();
export const updateAccountUserSchema = z.object({
  name: z.string().trim().min(1).max(120).optional(),
  accountAdmin: z.boolean().optional(),
  servicePermissions: customerServicePermissionsSchema.optional(),
  isActive: z.boolean().optional(),
  password: z.string().min(12).max(256).optional(),
}).strict().refine((value) => Object.keys(value).length > 0, 'Provide at least one user setting');
export interface AccountUserDto {
  id: string;
  name: string;
  email: string;
  accountAdmin: boolean;
  servicePermissions: CustomerServicePermission[];
  isActive: boolean;
  mustChangePassword: boolean;
}
